import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';

interface ConfirmDeleteModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemName?: string;
  isloading?: boolean;
}

const ConfirmDeleteModal = ({
  open,
  onClose,
  onConfirm,
  isloading = false,
  itemName = 'este item',
}: ConfirmDeleteModalProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmar Exclusão</DialogTitle>
      <DialogContent>
        <Typography>
          Você tem certeza que deseja excluir <strong>{itemName}</strong>? Essa
          ação não poderá ser desfeita.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit" disabled={isloading}>
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={isloading}
          startIcon={
            isloading ? (
              <CircularProgress size={20} color="inherit" />
            ) : undefined
          }
        >
          {isloading ? 'Excluindo...' : 'Excluir'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteModal;
